import { FC } from "react";
import { MDSTextVariant, MDSTextWeight, MDSToggle } from "@/mds";
import { ConfigurationListItem, ConfigurationListItemKind } from "../configuration.types";
import {
  RowLeft,
  RowTitle,
  RowDescription,
  ToggleRowContainer,
  ToggleRowContent,
} from "../configuration.styles";

export const ConfigurationListToggleRow: FC<
  Extract<ConfigurationListItem, { kind: ConfigurationListItemKind.Toggle }>
> = ({ id, title, description, checked, onChange }) => {
  return (
    <ToggleRowContainer hasRightSlot={false}>
      <ToggleRowContent>
        <MDSToggle
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          aria-label={`Toggle ${id}`}
        />
        <RowLeft>
          <RowTitle variant={MDSTextVariant.ParagraphSm} weight={MDSTextWeight.Medium}>
            {title}
          </RowTitle>
          {description ? (
            <RowDescription variant={MDSTextVariant.TextS}>{description}</RowDescription>
          ) : null}
        </RowLeft>
      </ToggleRowContent>
    </ToggleRowContainer>
  );
};
